import { render, staticRenderFns } from "./InputCategories.vue?vue&type=template&id=e62742e6&"
import script from "./InputCategories.vue?vue&type=script&lang=js&"
export * from "./InputCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports